import * as React from 'react'
import { RouteComponentProps } from 'react-router'
import {
  IStationUserInvite,
  IStationUserUpdate,
  IOrgObj,
  IMap,
  IStationUserSearchObject,
  IStationUserUpdateDTO
} from '../../../types'
import StationUserBottomPanel from './StationUserBottomPanel'
import StationUserInnerForm, { IFormValuesSubmit } from './StationUserInnerForm'
import EntityHeaderTitle from 'src/components/ui/entity/EntityHeaderTitle'
import { handleRedirect, phoneNumberSplit } from '../../../utils'
import StationUserGoinZonePane from '../../../containers/station-user/StationUserGoinZonePane'
import UIMessages from 'src/utils/ui-messages'
import StationUserPaneHeader from '../view/StationUserPaneHeader'
interface IStationUserFormProps {
  selectedOrg?: IOrgObj
  organizations: IMap<IOrgObj>
  stationUserId: string
  currentStationUser: IStationUserSearchObject
  onSubmit: (StationUser: IStationUserInvite | IStationUserUpdate) => Promise<any>
  onUpdate: (StationUser: IStationUserUpdateDTO) => Promise<any>
  fetchTeamMember: (id: string) => Promise<any>
  fetching: boolean
  processing: boolean
  routeProps: RouteComponentProps<any>
}

interface IStationUserFormState {
  activeTab: string
  isCompleted: boolean
  isLoading: boolean
}

class StationUserForm extends React.PureComponent<
  IStationUserFormProps & RouteComponentProps<any>,
  IStationUserFormState
> {
  private formRef = React.createRef<any>()

  constructor(props: any) {
    super(props)
    this.state = {
      activeTab: UIMessages.stationUser.userInfo,
      isCompleted: false,
      isLoading: false
    }
  }

  public componentDidMount() {
    this.props.fetchTeamMember(this.props.stationUserId)
  }

  public render() {
    const { selectedOrg, organizations, currentStationUser, processing, fetching } = this.props
    const { activeTab, isCompleted, isLoading } = this.state
    const {
      common: { edit, create },
      stationUser: { stationUser }
    } = UIMessages
    const redirectPath =
      !!currentStationUser && currentStationUser.id
        ? `/station-user/${this.props.currentStationUser.id}`
        : '/station-user'

    return (
      <div>
        <div className='p2'>
          <EntityHeaderTitle>{`${currentStationUser ? edit : create} ${stationUser}`}</EntityHeaderTitle>
        </div>
        {/* DISPLAY TAB WHEN EDITING*/}
        {!!currentStationUser && (
          <StationUserPaneHeader
            activeTab={activeTab}
            handleChangeTab={tab => {
              this.setState({ activeTab: tab })
              const editPath =
                tab === 'User Info'
                  ? `/station-user/edit/${currentStationUser.id}`
                  : `/station-user/${currentStationUser.id}/zones/edit`
              handleRedirect(editPath)
            }}
          />
        )}
        <StationUserInnerForm
          formRef={this.formRef}
          isEdit={!!currentStationUser}
          isLoading={isLoading}
          organizations={organizations}
          selectedOrg={selectedOrg}
          stationUser={currentStationUser}
          onSubmit={this.handleSubmit}
          onUpdate={this.handleUpdate}
        />
        <StationUserBottomPanel
          completed={isCompleted}
          isLoading={isLoading}
          fetching={fetching}
          processing={processing}
          onCancelClick={() => this.handleCancelClick(redirectPath)}
          onSubmitClick={this.handleSubmitButtonClick}
        />
      </div>
    )
  }

  private renderZones = (props: RouteComponentProps<any>) => {
    console.log('calling render zones')
    console.log('props: ', props)
    const showMessage = (msg: string) => {
      console.log('showing message: ', msg)
    }
    return <StationUserGoinZonePane serviceId={this.props.stationUserId} {...props} showMessage={showMessage} />
    /*
      <ServiceEditZones
        formRef={this.serviceZonesFormRefCallback}
        onStepSuccessfullyCompleted={this.handleDataSaved(`/${SERVICE_EDIT_URL.GOIN_ZONES}`)}
      />
    */
  }

  private handleSubmitButtonClick = () => {
    this.formRef.current.submitForm()
  }

  private showCompleted = () => {
    const redirectPath =
      !!this.props.currentStationUser && this.props.currentStationUser.id
        ? `/station-user/${this.props.currentStationUser.id}`
        : '/station-user'

    this.setState(
      {
        isCompleted: true,
        isLoading: false
      },
      () => this.props.history.push(redirectPath)
    )
  }

  private handleSubmit = async (sationUser: IFormValuesSubmit) => {
    const { countryCode, phoneNumber } = phoneNumberSplit(sationUser.phoneNumber)
    this.setState({ isLoading: true })
    return this.props
      .onSubmit({
        ...sationUser,
        phoneNumber,
        countryCode
      })
      .then(this.showCompleted)
      .catch((error: unknown) => {
        this.setState({ isLoading: false })
        console.error(error)
      })
  }

  private handleUpdate = async (stationUser: IStationUserUpdateDTO) => {
    const { countryCode, phoneNumber } = phoneNumberSplit(stationUser.phoneNumber)
    this.setState({ isLoading: true })
    return this.props
      .onUpdate({
        ...stationUser,
        phoneNumber,
        countryCode
      })
      .then(this.showCompleted)
      .catch((error: unknown) => {
        this.setState({ isLoading: false })
        console.error(error)
      })
  }

  private handleCancelClick = (redirectPath: string) => {
    handleRedirect(redirectPath)
  }
}

export default StationUserForm



// WEBPACK FOOTER //
// ./src/components/station-user/form/StationUserForm.tsx